import formatWithOptions from 'date-fns/fp/formatWithOptions';
import { ru } from './locale';
export var format = formatWithOptions({
  locale: ru
});